import React from "react";
import { X, Check } from "lucide-react";
import { motion } from "framer-motion";

const ResponsibilityToggle = ({ mode, onChange }) => {
  const toggleMode = () => {
    onChange(mode === "suggested" ? "current" : "suggested");
  };

  return (
    <div className="relative inline-block w-[70px] h-5">
      <motion.div
        className="absolute inset-0 cursor-pointer rounded-full transition-colors duration-300"
        animate={{
          backgroundColor: mode === "current" ? "#ef4444" : "#22c55e",
        }} // Red for current, green for suggested
        onClick={toggleMode}
      >
        <motion.div
          className="absolute inset-y-0 left-0 w-[35px] h-5 bg-white rounded-full shadow-md flex items-center justify-center cursor-pointer group"
          animate={{ x: mode === "current" ? 40 : 0 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        >
          {mode === "suggested" ? (
            <>
              <Check className="text-green-500 size-3" />
              <span className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity bg-gray-800 text-white p-1 rounded absolute left-1/2 -translate-x-1/2 -top-8 w-max text-xs z-50">
                Suggested
                <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800"></span>
              </span>
            </>
          ) : (
            <>
              <X className="text-red-500 size-3" />
              <span className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity bg-gray-800 text-white p-1 rounded absolute left-1/2 -translate-x-1/2 -top-8 w-max text-xs z-50">
                Current
                <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800"></span>
              </span>
            </>
          )}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ResponsibilityToggle;
